/**
 * 토큰 저장소 관리 (공유 레이어)
 * 환경변수에서 정의된 키 이름을 사용합니다
 */

const ACCESS_TOKEN_KEY =
  import.meta.env.VITE_ACCESS_TOKEN_NAME || "accessToken";
const REFRESH_TOKEN_KEY =
  import.meta.env.VITE_REFRESH_TOKEN_NAME || "refreshToken";
const PROFILE_ID_KEY = import.meta.env.VITE_PROFILE_ID_NAME || "profileId";

export const tokenStorage = {
  /**
   * 액세스 토큰 저장
   */
  setAccessToken(token: string): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  },

  /**
   * 액세스 토큰 조회
   */
  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  /**
   * 리프레시 토큰 저장
   */
  setRefreshToken(token: string): void {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  },

  /**
   * 리프레시 토큰 조회
   */
  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  /**
   * 프로필 ID 저장
   */
  setProfileId(profileId: string): void {
    localStorage.setItem(PROFILE_ID_KEY, profileId);
  },

  /**
   * 프로필 ID 조회
   */
  getProfileId(): string | null {
    return localStorage.getItem(PROFILE_ID_KEY);
  },

  /**
   * 모든 토큰 정보 조회
   */
  getAllTokens() {
    return {
      accessToken: this.getAccessToken(),
      refreshToken: this.getRefreshToken(),
      profileId: this.getProfileId(),
    };
  },

  /**
   * 모든 인증 정보 제거
   */
  clear(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(PROFILE_ID_KEY);
  },
};
